function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExercise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 0 60.86 60.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M43.245 54.418c-1.676-1.632-3.613-3.101-5.021-4.985-1.293-1.732-.67-2.475-.209-4.688.531-2.545 1.207-5.211 1.467-7.871q.27-.577.434-1.279c.564-2.473 1.331-4.92 1.467-7.466.197-3.746-.713-7.738-1.09-11.444-.322-3.167-2.363-5.868-5.806-5.89-1.921-.012-3.992 1.13-5.1 2.813-2.335 2.057-4.995 2.832-8.206 2.006-4.731-1.213-6.734 6.084-2.011 7.297 3.542.908 6.984.712 10.104-.488.189 1.669.35 3.341.414 5.01q.008.261-.003.521a7 7 0 0 1-.097.596c-.155.68-.323 1.358-.49 2.036-2.242-.899-4.567-1.608-6.886-2.247-1.814-.5-4.336.603-4.654 2.643-.679 4.372-.203 8.442 1.032 12.674 1.364 4.672 8.666 2.684 7.296-2.014-.439-1.502-.828-3.025-1.031-4.566 2.141.767 4.206 1.697 6.135 2.994q.213.142.427.252c-.492 2.028-1.086 4.096-1.356 5.795-.961 6.071 3.943 9.862 7.833 13.653 3.495 3.403 8.851-1.945 5.351-5.352",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.54,
    cy: 5.611,
    r: 5.611,
    style: {
      fill: "white"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercise);
export default __webpack_public_path__ + "static/media/exercise.be2cc4833e579b81493ef60ec95bddcc.svg";
export { ForwardRef as ReactComponent };